<div class="content-body default-height">
  <!-- Breadcrumb  -->
  <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkPropertyEdit ? 'Edit Property' : ''"
    (addEvent)="editPropertyEvent($event)" (editPropertyBackButton)="backToProperties($event)"> </app-breadcrumb>
  <div class="container-fluid">
    <div class="card profile-overview profile-overview-wide">
      <div class="card-body d-flex">
        <div class="clearfix">
            <!--
            <div class="d-inline-block position-relative me-sm-4 me-3 mb-3 mb-lg-0">
              <img [src]="selectedProperty.cover_image" alt="" class="rounded-4 profile-avatar" appDefaultImage>
            </div>
            -->
        </div>
        <div class="clearfix d-xl-flex flex-grow-1">
          <div class="clearfix pe-md-5">
            <h5 class="fw-semibold mb-1">{{selectedProperty?.name}}
            </h5>
            <ul class="d-flex flex-wrap fs-6 align-items-center property-view-address">
              <li class="me-3 d-inline-flex align-items-center">
                <i class="las la-home me-1 fs-18"></i>{{selectedProperty.address_1}}, {{selectedProperty.address_2}}
              </li>
              <!-- <li class="me-3 d-inline-flex align-items-center">
                      <i class="las la-home me-1 fs-18"></i>{{selectedProperty.address_line2}}
                    </li> -->
            </ul>
            <!-- <h5 class="p-0">Property Type : {{ selectedProperty.type}}</h5> -->
            <!-- <h5 class="p-0">Created At : {{ selectedProperty?.created_at}}</h5> -->
            <!-- <h5 class="p-0">Address : {{ selectedProperty.address}}</h5> -->
          </div>
          <div class="mt-1 d-flex ">
             <div class="ms-3" *ngIf="selectedProperty?.lease_details?.lease_amount">
              <h4 class="badge badge-md badge-success light border-0">Lease</h4>
              <div class="las la-rupee-sign p-1 btn-block">Amount: {{ selectedProperty.lease_details.lease_amount }} </div>
              <div class="las la-calendar p-1 btn-block">Start: {{ selectedProperty.lease_details.lease_start_date | date:'dd-MM-yyyy' }}</div>
              <div class="las la-calendar p-1 btn-block">End: {{ selectedProperty.lease_details.lease_end_date | date:'dd-MM-yyyy' }} </div>
            </div>
            <div class="ms-3" *ngIf="selectedProperty?.property_manager">
              <h4 class="badge badge-md badge-success light border-0">Property Manager</h4>
              <div class="las la-user p-1 btn-block"> {{ selectedProperty.property_manager.first_name }} {{
                selectedProperty.property_manager?.last_name }} </div>
              <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.property_manager.email }} </div>
              <div class="las la-phone p-1 btn-block"> {{ selectedProperty.property_manager.phone }} </div>
            </div>
            <div class="ms-3" *ngIf="selectedProperty?.owner">
              <h4 class="badge badge-md badge-success light border-0">Owner</h4>
              <div class="las la-user p-1 btn-block"> {{ selectedProperty.owner.first_name }} {{
                selectedProperty.owner.last_name }}</div>
              <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.owner.email }} </div>
              <div class="las la-phone p-1 btn-block"> {{ selectedProperty.owner.phone }} </div>
            </div>
            <div class="ms-3" *ngIf="selectedProperty?.lease_details?.tenant?.email">
              <h4 class="badge badge-md badge-success light border-0">Tenant</h4>
              <div class="las la-user p-1 btn-block"> {{ selectedProperty.lease_details.tenant.first_name }} {{
                selectedProperty.lease_details.tenant.last_name }} </div>
              <div class="las la-envelope p-1 btn-block"> {{ selectedProperty.lease_details.tenant.email }} </div>
              <div class="las la-phone p-1 btn-block"> {{ selectedProperty.lease_details.tenant.phone }} </div>
            </div>

          </div>
        </div>
      </div>
      <div class="m-2">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs tabs-display">

          <li [ngbNavItem]="1" *ngIf="checkPropertyDetailsTab">
            <a ngbNavLink>Property Details</a>
            <ng-template ngbNavContent>
              <div class="p-3">
                <div ngbAccordion class="{{ maneClass }}">
                  <div ngbAccordionItem [collapsed]="false">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        @if(maneClass && !positionClass && !iconClass){
                        <span>Property</span>
                        }
                        @if(iconClass){
                        <span class="{{ iconClass }}"></span>
                        }
                        @if(positionClass){
                        <span class="{{ positionClass }}">Property</span>
                        }
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <div class="row mt-2">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Project Name</span>
                            </div>
                            <div class="col-2 float-start">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty?.name}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">State</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.state}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">City</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.city}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Locality</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.locality}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Pincode</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.postal_code}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Type</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.type}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Latitude</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.latitude || '—'}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Longitude</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.longitude || '—'}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Maps Link</span>
                            </div>
                            <div class="col-2">
                              <a *ngIf="selectedProperty.maps_link" [href]="selectedProperty.maps_link" target="_blank"
                                class="fs-13 text-primary fw-semibold">View on Map</a>
                              <span *ngIf="!selectedProperty.maps_link" class="fs-13 text-secondary fw-semibold">—</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Listing Status</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.listing_status}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Monthly Rent</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.monthly_rent}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Inspection Required</span>
                            </div>
                            <div class="col-2">
                              <span
                                class="fs-13 text-secondary fw-semibold">{{selectedProperty.inspection_required}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">

                            <div class="col-2 ps-4">
                              <span class="fs-13">Monthly Maintenance</span>
                            </div>
                            <div class="col-2">
                              <span
                                class="fs-13 text-secondary fw-semibold">{{selectedProperty.monthly_maintenance}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Floor</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.floor}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Built Up Area</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.built_up_area}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Carpet Area</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.carpet_area}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Flooring Type</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.flooring_type}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Facing</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.facing}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Age of property</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.age_of_property}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Parking Type</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.parking_type}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Number of parking</span>
                            </div>
                            <div class="col-2">
                              <span
                                class="fs-13 text-secondary fw-semibold">{{selectedProperty.number_of_parkings}}</span>
                            </div>

                            <div class="col-2 ps-4">
                              <span class="fs-13">Parking Number</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.parking_number}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Parking Quantity</span>
                            </div>
                            <div class="col-2">
                              <span
                                class="fs-13 text-secondary fw-semibold">{{selectedProperty.parking_quantity}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Keys Quantity</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.keys_quantity}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Rental Type</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.rental_type}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Furnished Type</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.furnished_type}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Year Built</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.year_built}}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Video Url</span>
                            </div>
                            <div class="col-2">
                              <span
                                class="fs-13 text-secondary fw-semibold c-pointer" *ngIf="selectedProperty.video_url" (click)="viewVideoUrl(selectedProperty.video_url)">{{selectedProperty.video_url}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Property Visisble</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.property_visible}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Near By Info</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.near_by_info}}</span>
                            </div>

                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Notes</span>
                            </div>
                            <div class="col-2">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.notes}}</span>
                            </div>
                            <div class="col-2 ps-4">
                              <span class="fs-13">Property Category</span>
                            </div>
                            <div class="col-6">
                              <span class="fs-13 text-secondary fw-semibold">{{ propertyCategoryLabels.join(', ') }}</span>
                            </div>
                          </div>

                          <div class="row mt-3">
                            <div class="col-2 ps-4">
                              <span class="fs-13">Description</span>
                            </div>
                            <div class="col-10">
                              <span class="fs-13 text-secondary fw-semibold">{{selectedProperty.description}}</span>
                            </div>

                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionItem [collapsed]="true"
                    *ngIf="selectedProperty?.property_category?.property_category_sale && checkBuyerDetailsTab">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        <span>Buyer Details</span>
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <app-property-buyers [propertyId]="propertyId"></app-property-buyers>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionItem [collapsed]="true">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        @if(maneClass && !positionClass && !iconClass){
                        <span>Platforms</span>
                        }
                        @if(iconClass){
                        <span class="{{ iconClass }}"></span>
                        }
                        @if(positionClass){
                        <span class="{{ positionClass }}">Platforms</span>
                        }
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>

                          <div class="row">
                            <div class="col-xl-12">
                              <table id="empoloyees-tbl" class="table mb-0">
                                <thead>
                                  <tr>
                                    <th>Platform</th>
                                    <th>Platform Id</th>
                                    <th>Platform Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let platform of selectedProperty?.platforms">
                                    <th>
                                      {{ platform.platform_name }}
                                    </th>
                                    <th>
                                      {{ platform.property_platform_id }}
                                    </th>
                                    <th>
                                      {{ platform.property_platform_link }}
                                    </th>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionItem [collapsed]="true" *ngIf="checkPropertyAmenitiesTab">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        @if(maneClass && !positionClass && !iconClass){
                        <span>Amenities</span>
                        }
                        @if(iconClass){
                        <span class="{{ iconClass }}"></span>
                        }
                        @if(positionClass){
                        <span class="{{ positionClass }}">Amenities</span>
                        }
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template ngbNavContent>
                          <div class="p-3">
                            <div class="row p-3">
                              <p *ngIf="!selectedProperty.amenities?.length" class="text-center mt-2 no-docs">No amenity details
                                found</p>
                              <div class="col-md-3" *ngFor="let amenity of selectedProperty.amenities">
                                <ul class="list-group list-group-flush tick-display">
                                  <li class="list-group-item">
                                    {{ amenity }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div ngbAccordionItem [collapsed]="true" *ngIf="checkPropertyImagesTab">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        @if(maneClass && !positionClass && !iconClass){
                        <span>Images</span>
                        }
                        @if(iconClass){
                        <span class="{{ iconClass }}"></span>
                        }
                        @if(positionClass){
                        <span class="{{ positionClass }}">Images</span>
                        }
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <div class="p-3">
                            <p *ngIf="!propertyImages?.length" class="text-center mt-2 no-docs">No property images found</p>
                            <div class="row">
                              <div class="col-sm-4" *ngFor="let image of propertyImages">
                                <div class="box">
                                  <div class="imgbox c-pointer" (click)="viewPropertyImage(viewImagecontent)">
                                    <img [src]="image.image_link" class="img-display">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="7" *ngIf="checkPropertyLeaseTab">
            <a ngbNavLink>Leases</a>
            <ng-template ngbNavContent>
              <ng-container>
                <app-property-lease></app-property-lease>
              </ng-container>
            </ng-template>
          </li>
          <!-- <li [ngbNavItem]="3" *ngIf="checkPropertyAmenitiesTab">
            <a ngbNavLink>Amenities</a>
            <ng-template ngbNavContent>
              <div class="p-3">


                <div class="row p-3">
                  <p *ngIf="!selectedProperty.amenities?.length" class="text-center mt-2 no-docs">No amenity details
                    found</p>
                  <div class="col-md-3" *ngFor="let amenity of selectedProperty.amenities">
                    <ul class="list-group list-group-flush tick-display">
                      <li class="list-group-item">
                        {{ amenity }}
                      </li>
                    </ul>
                  </div>
                </div>




              </div>
            </ng-template>
          </li> -->
          <!-- <li [ngbNavItem]="4" *ngIf="checkPropertyImagesTab">
            <a ngbNavLink>Images</a>
            <ng-template ngbNavContent>
              <div class="p-3">
                <p *ngIf="!propertyImages?.length" class="text-center mt-2 no-docs">No property images found</p>
                <div class="row">
                  <div class="container-fluid">
                    <div class="container mt-0">
                      <div class="row">
                        <div class="col-sm-4" *ngFor="let image of propertyImages">
                          <div class="box">
                            <div class="imgbox c-pointer" (click)="viewPropertyImage(viewImagecontent)">
                              <img [src]="image.image_link" class="img-display">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li> -->
          <li [ngbNavItem]="5" *ngIf="checkPropertyBillsTab">
            <a ngbNavLink>Accounts</a>
            <ng-template ngbNavContent>
              <app-property-bills [bills]="selectedProperty.property_bills" (addBillEvent)="addPropertyBills()"
                (editBillEvent)="editBill($event)" (viewBillEvent)="viewBill($event)"></app-property-bills>
            </ng-template>
          </li>
          <li [ngbNavItem]="6" *ngIf="checkPropertyDocumentsTab">
            <a ngbNavLink>Documents</a>
            <ng-template ngbNavContent>
              <div class="p-1">
                <div class="row">
                  <div class="col-md-12">
                    <a *ngIf="checkAddDocument" class="badge light badge-success me-2 float-end c-pointer"
                      (click)="addDocuments()">Add Document</a>
                  </div>
                </div>
                <div class="row ps-2 mt-2">
                  <div class="col-xl-12">
                    <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
                      <table id="empoloyees-tbl" class="table mb-0">
                        <thead>
                          <tr>
                            <th>Document Name</th>
                            <th>Document Type</th>
                            <th>Description</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let document of propertyDocuments">
                            <td>
                              {{ document.name }}
                            </td>
                            <td>
                              {{ document.document_type }}
                            </td>
                            <td>
                              {{ document.description }}
                            </td>
                            <td>
                              <button *ngIf="checkViewDocument" type="button"
                                class="btn btn-success shadow btn-xs sharp me-1 mb-1"
                                (click)="viewImage(document.document_url)"><i class="fa fa-eye"></i></button>
                              <button *ngIf="checkDeleteDocument" type="button"
                                class="btn btn-danger shadow btn-xs sharp mb-1"
                                (click)="deletePropertyDocument(document.uid)"><i class="fa fa-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </li>
          <li [ngbNavItem]="8" *ngIf="checkPropertyEnquiriesTab">
            <a ngbNavLink>Enquiries</a>
            <ng-template ngbNavContent>
              <app-enquiries-list [propertyId]="propertyId" [hidePropertyColumn]="true"></app-enquiries-list>
            </ng-template>
          </li>
          <li [ngbNavItem]="9" *ngIf="checkPropertyTasksTab">
            <a ngbNavLink>Tasks</a>
            <ng-template ngbNavContent>
              <app-tasks-list [embedded]="true" [propertyId]="propertyId" [linkName]="selectedProperty?.name"></app-tasks-list>
            </ng-template>
          </li>
          <li [ngbNavItem]="2" *ngIf="checkPropertyRoomsTab">
            <a ngbNavLink>Rooms</a>
            <ng-template ngbNavContent>
              <div class="p-3">
                <p *ngIf="!propertyRoomsList.length" class="text-center mt-2 no-docs">No room details found</p>
                <div ngbAccordion class="{{ maneClass }}" *ngFor="let room of propertyRoomsList">
                  <div ngbAccordionItem [collapsed]="true">
                    <h2 ngbAccordionHeader [ngClass]="{'accordion-header accordion-header-primary': bg}">
                      <button ngbAccordionButton class="accordion-header rounded-lg">
                        @if(maneClass && !positionClass && !iconClass){
                        <span> {{ room.room_name }} </span>
                        }
                        @if(iconClass){
                        <span class="{{ iconClass }}"></span>
                        }
                        @if(positionClass){
                        <span class="{{ positionClass }}">{{ room.room_name }}</span>
                        }
                      </button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <div class="row">
                            <div class="col-md-3 room-list" *ngFor="let item of room.items; let i = index">
                              <div class="col-md-2 ps-4 mt-2" [ngClass]="i > 3 ? 'mt-4' : 'mt-2'">
                                <span class="fs-13"> {{ item.item_name }} </span>
                              </div>
                              <div class="col-md-1 mt-2" [ngClass]="i > 3 ? 'mt-4' : 'mt-2'">
                                <span class="fs-13 text-secondary fw-semibold">
                                  {{ item.item_quantity }}
                                </span>
                              </div>
                            </div>
                          </div>

                        </ng-template>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>


    </div>

  </div>
</div>

<div #addEditBillButton class="offcanvas offcanvas-end customeoff {{ add_property_bills ? 'show':''}}" tabindex="-1"
  id="add_property_bills">
  <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">{{ isEditBill ? "Edit" : "Add" }} Bill</h5>
    <button type="button" class="btn-close" (click)="addPropertyBillsClose()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="addBillsForm" (ngSubmit)="saveBill()" autocomplete="off">

        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Bill Name<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Bill Name"
              formControlName="name">
            <div *ngIf="addBillsForm?.get('name')?.invalid && addBillsForm?.get('name')?.touched" class="required">
              Bill Name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Bill Type<span
                class="text-danger">*</span></label>
            <select class="form-select" formControlName="bill_type">
              <option selected disabled value="null">Select bill type</option>
              <option *ngFor="let billType of defaultBillTypes" [value]="billType.key">{{billType.keyName}}</option>
            </select>
            <div *ngIf="addBillsForm?.get('bill_type')?.invalid && addBillsForm?.get('bill_type')?.touched"
              class="required">
              Bill Type is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Category<span
                class="text-danger">*</span></label>
            <select class="form-select" formControlName="bill_category_id" placeholder="category">
              <option data-display="Select" [ngValue]="null" selected>Please select</option>
              <option *ngFor="let property_type of billTypes" [value]="property_type.id">{{ property_type.name}}
              </option>
            </select>
            <div *ngIf="addBillsForm?.get('bill_category_id')?.invalid && addBillsForm?.get('bill_category_id')?.touched"
              class="required">
              Category is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Amount<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="0"
              formControlName="amount" (input)="showTotal()">
            <div *ngIf="addBillsForm?.get('amount')?.invalid && addBillsForm?.get('amount')?.touched" class="required">
              Bill Amount is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label class="form-label">
              Bank Account<span class="text-danger" *ngIf="addBillsForm?.get('taxable')?.value">*</span>
            </label>
            <select class="form-select" formControlName="bank_account_id">
              <option [ngValue]="null" selected>Please select</option>
              <option *ngFor="let acc of bankAccounts" [value]="acc.id">
                {{ acc.bank_name }} — {{ acc.display_name }} ({{ acc.account_number }})
              </option>
            </select>
            <small class="text-muted" *ngIf="selectedBankInvoiceFormat">
              Invoice ID format: <code>{{ selectedBankInvoiceFormat }}</code>
            </small>
            <div *ngIf="addBillsForm?.get('taxable')?.value
                  && addBillsForm?.get('bank_account_id')?.invalid
                  && addBillsForm?.get('bank_account_id')?.touched"
                class="required">
              Bank Account is required for taxable bills
            </div>
          </div>

          <!-- <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Bill To<span class="text-danger">*</span></label>
            <div>
              <select class="form-select" formControlName="role_identifier" (change)="updateTenantVisibility()">
                <option value="null" disabled selected>Recipient</option>
                <option value="property_manager">Property Manager</option>
                <option value="owner">Owner</option>
                <option value="tenant">Tenant</option>
              </select>
              <div
                *ngIf="addBillsForm?.get('role_identifier')?.invalid && addBillsForm?.get('role_identifier')?.touched"
                class="required">
                Bill to is required
              </div>
            </div>
          </div> -->

          <div class="col-xl-4 mb-1">
            <div class="d-flex gap-2">
              <div class="col-xl-2 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Tenant Visibility</label>
              </div>
              <div class="col-xl-2 w-50">
                <input type="checkbox" class="form-check-input" formControlName="tenant_visibility">
              </div>
            </div>
          </div>

          <div class="col-xl-5 mb-1">
            <div class="d-flex gap-2">
              <div class="col-xl-4 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Auto generated invoice</label>
              </div>
              <div class="col-xl-1 w-50">
                <input type="checkbox" class="form-check-input" formControlName="auto_invoice">
              </div>
            </div>
          </div>

          <div class="col-xl-3 mt-1">
            <div class="d-flex gap-2">
              <div class="col-xl-2 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Taxable Bill</label>
              </div>
              <div class="col-xl-1 w-50">
                <input type="checkbox" class="form-check-input ms-3" formControlName="taxable"
                  (change)="displayTaxDetails">
              </div>
            </div>
          </div>

          <div class="col-xl-6 mb-3 mt-2" *ngIf="displayTaxDetails">
            <label for="exampleFormControlInput1-2" class="form-label">State GST(%)<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="0"
              formControlName="sgst_per" (input)="calculateTotal()">
            <div *ngIf="addBillsForm?.get('sgst_per')?.invalid && addBillsForm?.get('sgst_per')?.touched"
              class="required">
              <p *ngIf="addBillsForm.get('sgst_per')?.errors?.['required']">
                State gst is required
              </p>
              <p *ngIf="addBillsForm.get('sgst_per')?.errors?.['max']">
                State gst cannot be more than 15
              </p>
            </div>
          </div>

          <div class="col-xl-6 mb-3 mt-2" *ngIf="displayTaxDetails">
            <label for="exampleFormControlInput1-2" class="form-label">Central GST(%)<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="0"
              formControlName="cgst_per" (input)="calculateTotal()">
            <div *ngIf="addBillsForm?.get('cgst_per')?.invalid && addBillsForm?.get('cgst_per')?.touched"
              class="required">
              <p *ngIf="addBillsForm.get('cgst_per')?.errors?.['required']">
                Central gst is required
              </p>
              <p *ngIf="addBillsForm.get('cgst_per')?.errors?.['max']">
                Central gst cannot be more than 15
              </p>
            </div>
          </div>

          <div class="col-xl-6 mb-3 mt-2">
            <label for="exampleFormControlInput1-2" class="form-label">Discount(%)</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="0"
              formControlName="discount_per" (input)="calculateTotal()">
          </div>

          <div class="col-xl-6 align-content-center mt-3">
            <div class="d-flex gap-2">
              <div class="col-xl-1 total-width">
                <label for="exampleFormControlInput1-1" class="form-label">Total</label>
              </div>
              <div class="col-xl-1 w-50 fw-bolder">
                {{total_amount}}
              </div>
            </div>
          </div>

          <div class="col-xl-6 mb-3" *ngIf="isEditBill">
            <label for="exampleFormControlInput1-2" class="form-label">Paid Date</label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date " formControlName="paid_date">
          </div>

          <div class="col-xl-6 mb-3" *ngIf="isEditBill && displayTaxDetails">
            <label for="exampleFormControlInput1-3" class="form-label">Invoice Date<span class="text-danger" *ngIf="addBillsForm.get('status')?.value === 'Paid'">*</span></label>
            <input type="date" class="form-control" id="exampleFormControlInput1-2" placeholder="Invoice Date" formControlName="invoice_date">
            <div *ngIf="addBillsForm?.get('invoice_date')?.invalid && addBillsForm?.get('invoice_date')?.touched" class="required">
              Invoice Date is required when bill is Paid and Taxable
            </div>
          </div>

          <div class="col-xl-6 mb-3" *ngIf="isEditBill">
            <label for="exampleFormControlInput1-1" class="form-label">Status</label>
            <select class="form-select" formControlName="status" (change)="onStatusChange()">
              <option value="null" selected disabled>Select Status</option>
              <option value="Pending">Pending</option>
              <option value="Paid">Paid</option>
              <option value="Unpaid">Unpaid</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>


          <div class="col-xl-6 mb-3" *ngIf="isEditBill">
            <label for="exampleFormControlInput1-1" class="form-label">Payment Mode</label>
            <select class="form-select" formControlName="payment_mode">
              <option value="null" selected disabled>Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Google Pay">Google Pay</option>
              <option value="Paytm">Paytm</option>
              <option value="Direct Debit">Direct Debit</option>
              <option value="UPI">UPI</option>
              <option value="Credit Card">Credit Card</option>
              <option value="NEFT/RTGS">NEFT/RTGS</option>
              <option value="Cheque">Cheque</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div class="col-xl-6 mb-3" *ngIf="isEditBill">
            <label for="exampleFormControlInput1-1" class="form-label">Transaction ID</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Transaction ID"
              formControlName="transaction_id" >
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Memo/ Notes</label>
            <textarea class="form-control" id="exampleFormControlInput1-1" placeholder="0"
              formControlName="details"></textarea>
          </div>

        </div>
        <div class="col-xl-12 mb-3" *ngIf="uploadedImages?.length">
          <div *ngFor="let img of uploadedImages; let i = index">
            <div class="row">
              <div class="col-md-6">
                <p class="badge light badge-light"> {{ img.original_name }} </p>
              </div>
              <div class="col-md-6">
                <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.url)"> View </p>
                <p class="badge light badge-danger c-pointer" (click)="deleteImage(img.uid)"> Delete </p>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <label>Upload Bills</label>
          <div class="dz-default dlab-message upload-img mb-3">
            <div class="dropzone">
              <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667"
                  stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div class="fallback">
                <input name="file" type="file" accept="image/*,.pdf" formControlName="files" multiple
                  (change)="uploadBills($event)">

              </div>
            </div>
          </div>
        </div>
        <div>
          <button *ngIf="checkEditBill" class="btn btn-primary ms-1 me-3" type="submit"
            [disabled]="addBillsForm.invalid || loadingService.isLoading()">Submit</button>
          <button class="btn btn-danger lightme-1" type="button" (click)="addPropertyBillsClose()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
@if(add_property_bills){
<div class="offcanvas-backdrop fade show" (click)="addPropertyBills()"></div>
}

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Bill Image</h5>
    <button type="button" class="btn-close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <img [src]="displayImage" class="w-100" />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
  </div>
</ng-template>


<ng-template #viewBillBlock let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Bill Details</h5>
    <button type="button" class="btn-close" (click)="closeBillModal()"></button>
  </div>
  <div class="modal-body">

    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">Bill Name</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.name}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Bill Type</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.bill_type}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Category</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.category}}</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">Bill Amount</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.amount}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Bill Date</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.created_at | date:'dd-MM-yyyy'}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Bill To</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.role_identifier}}</span>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">Tenant Visibility</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.tenant_visibility}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Auto Generated Invoice</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.auto_invoice}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Is Bill Taxable</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.taxable}}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">State GST</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.sgst_per}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Central GST</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.cgst_per}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Discount</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.discount_per}}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">Payment Mode</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.payment_mode !='null' ? allBills.payment_mode :
          ""}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Status</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.status}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Paid Date</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.paid_date | date:'dd-MM-yyyy'}}</span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-2 ps-4">
        <span class="fs-13">Total Amount</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.total_amount}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Created Data</span>
      </div>
      <div class="col-2">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.created_at | date:'dd-MM-yyyy'}}</span>
      </div>
      <div class="col-2 ps-4">
        <span class="fs-13">Memo/Details</span>
      </div>
      <div class="col-6">
        <span class="fs-13 text-secondary fw-semibold">{{allBills.details}}</span>
      </div>
    </div>

    <div class="col-xl-12 mt-4" *ngIf="allBills.uploads?.length">
      <span class="fs-13 mb-3">Bill Files</span>
      <div *ngFor="let img of allBills.uploads; let i = index">
        <div class="row">
          <div class="col-md-6">
            <p class="badge light badge-light"> {{ img.original_name }} </p>
          </div>
          <div class="col-md-6">
            <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.url)"> View </p>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-primary ms-1 me-3 me-auto" type="button" (click)="payWithRazorpay(allBills.uid)" *ngIf="allBills.allow_payment">Pay Now</button>
    <button type="button" class="btn btn-secondary" (click)="closeBillModal()">Close</button>
  </div>
</ng-template>

<div class="offcanvas offcanvas-end customeoff {{ view_bill_details ? 'show':''}}" tabindex="-1" id="view_bill_details"
  data-bs-backdrop="static" *ngIf="allBills">
  <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">View Bill</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" (click)="viewBillDetails()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">

      <div class="row">
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Bill Name</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{allBills.name}}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Bill Type</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.bill_type == "1" ? "Income" : "Expense"
            }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Category</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.category }}</span>
        </div>

        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Bill Amount</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.amount }}</span>
        </div>

        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Bill Date</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.created_at | date:'dd-MM-yyyy' }}</span>
        </div>
        <div class="col-xl-12 mb-3" *ngIf="allBills?.bank_account">
          <label class="form-label">Bank Account</label>
          <div class="ms-3 fs-13 text-secondary">
            <div><strong>{{ allBills.bank_account.bank_name }}</strong>
              <span *ngIf="allBills.bank_account.display_name && allBills.bank_account.display_name !== allBills.bank_account.bank_name">
                — {{ allBills.bank_account.display_name }}
              </span>
              <span *ngIf="allBills.bank_account.invoice_name && allBills.bank_account.invoice_name !== allBills.bank_account.display_name">
                ({{ allBills.bank_account.invoice_name }})
              </span>
            </div>
            <div>Account: {{ allBills.bank_account.account_name }} — {{ allBills.bank_account.account_number }}</div>
            <div>IFSC: {{ allBills.bank_account.ifsc_code }}<span *ngIf="allBills.bank_account.branch_name"> · {{ allBills.bank_account.branch_name }}</span></div>
            <div *ngIf="allBills.bank_account.gstin">GSTIN: {{ allBills.bank_account.gstin }}</div>
            <div *ngIf="allBills.bank_account.address">{{ allBills.bank_account.address }}</div>
            <div *ngIf="allBills.bank_account.phone || allBills.bank_account.email">
              <span *ngIf="allBills.bank_account.phone">{{ allBills.bank_account.phone }}</span>
              <span *ngIf="allBills.bank_account.phone && allBills.bank_account.email"> · </span>
              <span *ngIf="allBills.bank_account.email">{{ allBills.bank_account.email }}</span>
            </div>
          </div>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Bill To</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.role_identifier }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Tenant Visibility</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.tenant_visibility }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Auto Generated Invoice</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.auto_invoice }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Is Bill Taxable</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.taxable }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">State GST</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.sgst_per }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Central GST</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.cgst_per }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Discount</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.discount_per }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Payment Mode</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.payment_mode !='null' ? allBills.payment_mode
            : "" }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Status</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.status }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Paid Date</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.paid_date | date:'dd-MM-yyyy' }}</span>
        </div>
        <div class="col-xl-4 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Total Amount</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.total_amount }}</span>
        </div>
        <div class="col-xl-4 mb-3" *ngIf="allBills.transaction_id">
          <label for="exampleFormControlInput1-1" class="form-label">Transaction ID</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.transaction_id }}</span>
        </div>
        <div class="col-xl-4 mb-3" *ngIf="allBills.order_id">
          <label for="exampleFormControlInput1-1" class="form-label">Order ID</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.order_id }}</span>
        </div>
        <div class="col-xl-12 mb-3">
          <label for="exampleFormControlInput1-1" class="form-label">Details</label>
          <span class="fs-13 text-secondary fw-semibold ms-3">{{ allBills.details }}</span>
        </div>

        <div class="col-xl-12 mt-2" *ngIf="allBills.uploads?.length">
          <span class="fs-13 mb-3">Bill Files</span>
          <div *ngFor="let img of allBills.uploads; let i = index">
            <div class="row">
              <div class="col-md-6">
                <p class="badge light badge-light"> {{ img.original_name }} </p>
              </div>
              <div class="col-md-6">
                <p class="badge light badge-primary me-3 ms-3 c-pointer" (click)="viewImage(img.url)"> View </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div>
        <button class="btn btn-primary ms-1 me-3" type="button" *ngIf="allBills.allow_payment" (click)="payWithRazorpay(allBills.uid)">Pay Now</button>
        <button class="btn btn-danger lightme-1 float-end" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
          (click)="viewBillDetails()">Close</button>
      </div>

    </div>
  </div>
</div>
@if(view_bill_details){
<div class="offcanvas-backdrop fade show" (click)="viewBillDetails()"></div>
}

<div #add_documents_popup class="offcanvas offcanvas-end customeoff {{ add_documents ? 'show':''}}" tabindex="-1"
  id="add_documents" data-bs-backdrop="static">
  <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Add Document</h5>
    <button type="button" class="btn-close" (click)="addDocumentClose()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="addDocumentForm" (ngSubmit)="submitDocument()" autocomplete="off">

        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Document Name<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Doc name"
              formControlName="name">
            <div *ngIf="addDocumentForm?.get('name')?.invalid && addDocumentForm?.get('name')?.touched"
              class="required">
              Document Name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Document Type<span
                class="text-danger">*</span></label>
            <select class="form-select" formControlName="document_type" placeholder="Bill Type">
              <option data-display="Select" value="null" selected>Please select</option>
              <option value="Encumbrance Certificate">Encumbrance Certificate</option>
              <option value="Layout Diagram">Layout Diagram</option>
              <option value="SiteMap">SiteMap</option>
              <option value="Land Verification">Land Verification</option>
              <option value="Property valuation">Property Valuation</option>
              <option value="Letter of Authorization">Letter of Authorization</option>
              <option value="Building Layout">Building Layout</option>
              <option value="Inspection Report">Inspection Report</option>
              <option value="Property Management Document">Property Management Document</option>
              <option value="Rental Agreement">Rental Agreement</option>
              <option value="Property Advisement ">Property Advisement </option>
              <option value="Tenant Terms & Conditions">Tenant Terms & Conditions</option>
              <option value="Owner Terms & Conditions">Owner Terms & Conditions</option>
              <option value="Accounts Excel Sheet">Accounts Excel Sheet</option>
              <option value="Accounts Pdf Sheet">Accounts Pdf Sheet</option>
              <option value="Aadhar card">Aadhar card</option>
              <option value="Pancard">Pancard</option>
              <option value="Employee ID">Employee ID</option>
              <option value="Passport">Passport</option>
              <option value="Driving Licence">Driving Licence</option>
              <option value="Others">Others</option>
            </select>
            <div
              *ngIf="addDocumentForm?.get('document_type')?.invalid && addDocumentForm?.get('document_type')?.touched"
              class="required">
              Document Type is required
            </div>
          </div>
          <div class="col-xl-12 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Description<span
                class="text-danger">*</span></label>
            <textarea type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Description"
              formControlName="description"></textarea>
            <div *ngIf="addDocumentForm?.get('description')?.invalid && addDocumentForm?.get('description')?.touched"
              class="required">
              Description is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <div class="d-flex gap-2">
              <div class="col-xl-3 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Tenant Visibility</label>
              </div>
              <div class="col-xl-3 w-50">
                <input type="checkbox" class="form-check-input" formControlName="tenant_visible">
              </div>
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <div class="d-flex gap-2">
              <div class="col-xl-3 w-50">
                <label for="exampleFormControlInput1-1" class="form-label">Owner Visibility</label>
              </div>
              <div class="col-xl-3 w-50">
                <input type="checkbox" class="form-check-input" formControlName="owner_visible">
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <label>Document<span class="text-danger">*</span></label>
          <div class="dz-default dlab-message upload-img mb-3">
            <div class="dropzone">
              <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667"
                  stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <div class="fallback">
                <input name="file" type="file" accept="image/*,.pdf,.doc,.xls,.xlsx" formControlName="document"
                  (change)="onImageChange($event)">

              </div>
            </div>
          </div>
          <div *ngIf="addDocumentForm?.get('document')?.invalid && addDocumentForm?.get('document')?.touched"
            class="required">
            Document is required
          </div>
        </div>
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit"
            [disabled]="addDocumentForm.invalid || loadingService.isLoading()">Submit</button>
          <button class="btn btn-danger lightme-1" type="button" (click)="addDocumentClose()">Cancel</button>
        </div>
      </form>
    </div>
  </div>
</div>
@if(add_documents){
<div class="offcanvas-backdrop fade show" (click)="addDocuments()"></div>
}

<ng-template #viewImagecontent let-modal>
  <div class="modal-header">
    <h5 class="modal-title"> Property Images </h5>
    <button type="button" class="btn-close" (click)="closeImageModal()"></button>
  </div>
  <div class="modal-body">
    <ngb-carousel class="fixed-height-carousel">

      <ng-template ngbSlide *ngFor="let image of propertyImages">
        <div class="picsum-img-wrapper">
          <img [src]="image.image_link" alt="" class="d-block w-100" />
        </div>
      </ng-template>

    </ngb-carousel>
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-secondary" (click)="prevImage(selectedImage.index)" [disabled]="selectedImage.prevImageDisable">Prev</button> -->
    <button type="button" class="btn btn-secondary" (click)="closeImageModal()">Close</button>
  </div>
</ng-template>
